import { useCallback, useEffect, useState } from 'react';
import { CONNECTION_TYPE, getNetInfo, useNetInfo } from 'DeviceUtils';
import storeActions from 'Store/storeActions';
import { useStore } from 'Store';

const useConnection = () => {
    const [showCellularWarning, setShowCellularWarning] = useState(false);
    const [connected, setConnected] = useState(true);
    const [retryConnect, setRetryConnect] = useState(false);
    const netInfo = useNetInfo();
    const { deviceStorageState, deviceStorageDispatch } = useStore();

    const checkConnectionType = useCallback(async () => {
        try {
            const currentNetInfo = await getNetInfo();
            if (currentNetInfo.type === CONNECTION_TYPE.CELLULAR) {
                setShowCellularWarning(deviceStorageState.showMobileNetworkWarning);
            }
        } catch (error) {
            console.log(error);
        }
    }, [deviceStorageState.showMobileNetworkWarning]);

    // Set cellular warning also if connection type is changed
    useEffect(() => {
        const asyncNetInfo = async () => {
            const promisedNetInfo = await Promise.resolve(netInfo);
            if (promisedNetInfo.type !== CONNECTION_TYPE.UNKNOWN) {
                if (promisedNetInfo.type === CONNECTION_TYPE.CELLULAR) {
                    checkConnectionType();
                } else if (promisedNetInfo.isInternetReachable) {
                    setConnected(true);
                } else {
                    setConnected(false);
                }
            }
            setRetryConnect(false);
        };
        asyncNetInfo();
    }, [netInfo, connected, checkConnectionType, retryConnect]);

    const discardCellularWarning = useCallback(() => setShowCellularWarning(false), []);

    // Artificially set connection to positive to trigger effect
    const retryConnection = useCallback(() => setRetryConnect(true), []);

    const dontShowAgainPress = useCallback(
        (isChecked) => {
            deviceStorageDispatch({
                type: storeActions.setShowMobileNetworkWarning,
                payload: !isChecked
            });
        },
        [deviceStorageDispatch]
    );

    return {
        showCellularWarning,
        setShowCellularWarning,
        discardCellularWarning,
        retryConnection,
        dontShowAgainPress,
        connected
    };
};

export default useConnection;
